/**
 * FilterValueSelector Component
 *
 * Routes to the appropriate value selector based on field data type and operator.
 * Delegates to specialized components for each type.
 *
 * @module FilterEditor/FilterValueSelector
 */

import React from 'react';

import type { ValueSelectorProps } from './types';
import { BooleanValueSelector } from './BooleanValueSelector';
import { DateValueSelector } from './DateValueSelector';
import { NumberValueSelector } from './NumberValueSelector';
import { TextValueSelector } from './TextValueSelector';

export const FilterValueSelector: React.FC<ValueSelectorProps> = (props) => {
  const { filter, selectedField } = props;

  // No value input needed for null checks
  if (filter.operator === 'is_null' || filter.operator === 'is_not_null') {
    return null;
  }

  // Boolean field - show true/false select
  if (selectedField?.data_type === 'boolean') {
    return <BooleanValueSelector {...props} />;
  }

  // Date/datetime fields - show date/datetime input
  if (selectedField?.data_type === 'date' || selectedField?.data_type === 'datetime') {
    return <DateValueSelector {...props} />;
  }

  // Number field - show number input
  if (selectedField?.data_type === 'number') {
    return <NumberValueSelector {...props} />;
  }

  // Text/email/url fields - show combobox with values
  return <TextValueSelector {...props} />;
};
